import React, { useEffect, useRef } from 'react';
import Multiselect from 'multiselect-react-dropdown';

// https://multiselect-react-dropdown.vercel.app/?path=/docs/multiselect-dropdown--flat-array
const MultiSelectListControl = ({ field,
  values,
  textValuePairs,
  onChange,
  onBlur,
  onSearch,
  className,
  disabled,
  loading,
  props,
  'aria-invalid': ariaInvalid,
  'aria-describedby': ariaDescribedBy,
}) => {

  const labelId = "field_lbl_sl_" + field.FieldName;
  const containerId = "field_msl_" + field.FieldName;
  const containerRef = useRef(null);

  // multiselect-react-dropdown renders its own <ul>/<li> option list and does
  // not expose props to set ARIA roles on it directly. Since the library
  // already supports arrow-key navigation internally, we only need to
  // annotate the rendered markup with the correct listbox/option semantics;
  // a MutationObserver keeps those attributes correct as the library
  // re-renders the list (opening, filtering, selecting).
  useEffect(() => {
    const node = containerRef.current;
    if (!node) return undefined;

    const applyAriaRoles = () => {
      const optionList = node.querySelector('ul.optionContainer');
      if (optionList) {
        optionList.setAttribute('role', 'listbox');
        optionList.setAttribute('aria-multiselectable', 'true');
        optionList.setAttribute('aria-labelledby', labelId);
        optionList.querySelectorAll('li.option, li.groupChildEle').forEach((li) => {
          li.setAttribute('role', 'option');
          li.setAttribute('aria-selected', li.classList.contains('selected') ? 'true' : 'false');
        });
      }
    };

    applyAriaRoles();
    const observer = new MutationObserver(applyAriaRoles);
    observer.observe(node, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, [textValuePairs, values, labelId]);

  return (
    <div ref={containerRef} aria-invalid={ariaInvalid} aria-describedby={ariaDescribedBy}>
      <label {...(field.IsRequired && { required: true })} id={labelId} htmlFor={`${containerId}_input`}>{field.DisplayName}</label>
      <Multiselect
        id={containerId}
        loading={loading}
        disable={disabled}
        className={className}
        placeholder={field.PlaceHolder}
        displayValue="Text"
        selectedValues={values}
        onRemove={(selectedList) => onChange ? onChange(selectedList, field) : null}
        onSearch={onSearch}
        onSelect={(selectedList) => onChange ? onChange(selectedList, field) : null}
        options={textValuePairs}
        showCheckbox
        {...props}
      />
    </div>
  );
}

export default MultiSelectListControl;